import MessagingBase from './messaging-base';

export default class MessagingUser extends MessagingBase {}
